// @ts-nocheck
export default (obj, attr) => delete obj[attr]
